module.exports = __webpack_public_path__ + "img/img_company_default@2x.8242017.png";